/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource>): RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource {
        let obj = Object.assign(new RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource(), model);
        RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource>): RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource {
        if (!model) return null;
        return RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource.newInstance(<RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource) {
        if (!obj) return;

        models.RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsUnderUtilizedAwsLambdaComputeOptimizerResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
